import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { FormState, phoneRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import firebaseApp, { auth, refreshToken } from '../../../firebase-init';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();
  const [establishments, setEstablishments] = useState([]);

  const getEstablishments = async () => {
    await refreshToken();

    AxiosInstance.get('/establishment')
      .then((res) => {
        setEstablishments(res.data.items);
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_GET_ESTABLISHMENT'), '', 'error');
      });
  };

  useEffect(() => {
    getEstablishments();
  }, []);

  const inputValues = {
    firstName: { value: '', validate: { required: true } },
    lastName: { value: '', validate: { required: true } },
    gender: { value: 'M', validate: { required: true } },
    bac_matricule: { value: '', validate: { required: false } },
    phone: { value: '', validate: { required: false, pattern: phoneRegex } },
    level: { value: '', validate: { required: true } },
    establishment: { value: '', validate: { required: true } },
  };

  const [loading, setLoading] = useState(false);

  const savePersonalData = async (e) => {
    // console.log({values: formState.inputValues})
    setLoading(true);
    
    console.log('🔍 Getting current Firebase user email...');
    const currentUserEmail = auth.currentUser?.email;
    console.log('🔍 Current user email:', currentUserEmail);
    
    console.log('🔍 Firebase current user:', auth.currentUser);
    console.log('🔍 Firebase current user UID:', auth.currentUser?.uid);
    
    const requestData = {
      firstName: formState.inputValues.firstName,
      lastName: formState.inputValues.lastName,
      phone: formState.inputValues.phone,
      bac_matricule: formState.inputValues.bac_matricule,
      gender: formState.inputValues.gender,
      level: formState.inputValues.level,
      establishmentId: formState.inputValues.establishment,
      email: currentUserEmail || 'dummyemail@test.com',
    };
    
    console.log('🔍 Sending personal information request:', JSON.stringify(requestData, null, 2));
    console.log('🔍 AxiosInstance baseURL:', AxiosInstance.defaults?.baseURL);
    console.log('🔍 AxiosInstance headers:', AxiosInstance.defaults?.headers?.common);
    
    AxiosInstance.post(`/auth/personal-information`, requestData)
      .then(async (responseData) => {
        console.log('✅ Response received:', responseData);
        setLoading(false);
        
        if (!responseData) {
          history.push('/personal-information');
        } else {
          await auth.currentUser.updateProfile({
            displayName: formState.inputValues.firstName + ' ' + formState.inputValues.lastName,
          });
          await auth.currentUser.getIdTokenResult(true);
          window.location.replace('/');
        }
      })
      .catch((error) => {
        console.error('❌ Error saving personal information:', error);
        console.error('❌ Error response:', error?.response);
        console.error('❌ Error data:', error?.response?.data);
        
        if (error?.response?.status === 400) {
          const errorMsg = error.response.data?.message || error.response.data?.message || t('ERROR_SAVING_PERSONAL_DATA');
          console.error('❌ Error message:', errorMsg);
          handleErrorsServer(errorMsg);
        } else {
          const errorMsg = error?.response?.data?.message || error?.message || t('ERROR_SAVING_PERSONAL_DATA');
          console.error('❌ Generic error message:', errorMsg);
          Swal.fire(t('ERROR_SAVING_PERSONAL_DATA'), errorMsg, 'error');
        }
        setLoading(false);
      });
  };

  const redirectToLogin = (e) => {
    e.preventDefault();
    history.push('/login');
  };

  const { formState, submitHandler, resetFormState, field, handleErrorsServer } = FormState(inputValues, savePersonalData);
  React.useEffect(() => {
    console.log({ formState });
  }, [formState]);
  return {
    submitHandler,
    formState,
    field,
    redirectToLogin,
    loading,
    establishments,
  };
};

export default useForm;
